import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-power",
  "use": "icon-power-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" class=\"bi bi-power\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-power\">\r\n  <path fill-rule=\"evenodd\" d=\"M5.578 4.437a5 5 0 1 0 4.922.044l.5-.866a6 6 0 1 1-5.908-.053l.486.875z\" />\r\n  <path fill-rule=\"evenodd\" d=\"M7.5 8V1h1v7h-1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/power.svg
// module id = aUH0
// module chunks = 60